import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  id: "first-time-avatar"
};
const _hoisted_2 = {
  class: "first-time-avatar-box d-flex flex-column align-items-center"
};
const _hoisted_3 = {
  class: "first-time-avatar-box__body flex-fill d-flex flex-column justify-content-center align-items-center"
};
const _hoisted_4 = {
  class: "frame"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "请前往修改昵称与头像", -1);
const _hoisted_7 = {
  class: "first-time-avatar-box__buttons d-flex align-items-center"
};
import { useState } from '@/utils/map-state';
import { reactive, toRaw } from "vue";
import { useRouter } from "vue-router";
import { _isApp, _isMobile } from "@/utils";
export default {
  __name: 'FirstTimeAvatarPopup',
  setup(__props) {
    const router = useRouter();
    const userState = useState('user', ['userInfo']);
    let {
      userInfo
    } = userState;
    let state = reactive({
      isShowFirstTimeAvatar: false
    });
    let showFirstTimeAvatar = () => {
      state.isShowFirstTimeAvatar = false;
    };
    let gotoEditAvatar = () => {
      state.isShowFirstTimeAvatar = false;
      router.push('/user/' + uid + '/settings');
    };

    // 判斷是否提示修改頭像
    const uid = toRaw(userInfo.value).uid;
    const storageData = JSON.parse(localStorage.getItem('fb78682f97'));
    if (storageData && storageData[uid] <= 0) {
      storageData[uid] = 1;
      localStorage.setItem('fb78682f97', JSON.stringify(storageData));
      state.isShowFirstTimeAvatar = true;
    }
    return (_ctx, _cache) => {
      return _unref(state).isShowFirstTimeAvatar ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("i", {
        class: "first-time-avatar-box__close ico-close",
        onClick: _cache[0] || (_cache[0] = (...args) => _unref(showFirstTimeAvatar) && _unref(showFirstTimeAvatar)(...args))
      }), _createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, [_createElementVNode("img", {
        class: "avatar",
        src: _ctx.$filters.promoteUrl('/uc_server/avatar.php?uid=' + _unref(userInfo).uid + '&size=middle')
      }, null, 8, _hoisted_5)]), _hoisted_6]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "btn-confirm",
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(gotoEditAvatar) && _unref(gotoEditAvatar)(...args))
      }, "前往修改")])])])) : _createCommentVNode("", true);
    };
  }
};